module.exports = __webpack_public_path__ + "static/media/toxinsicon.0d3dbfa8.png";